import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/shared/auth/auth.service';
import { ConsultasSqlApi } from 'app/shared/lb-sdk';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

export interface ParametroItem {
  idparametro?: number;
  nombre: string;
  valor: string;
  descripcion?: string;
}

@Component({
  selector: 'app-abm-parametros',
  templateUrl: './abm-parametros.component.html',
  styleUrls: ['./abm-parametros.component.scss']
})
export class AbmParametrosComponent implements OnInit {
  parametros: ParametroItem[] = [];
  editando: ParametroItem = null;
  form: ParametroItem = { nombre: '', valor: '', descripcion: '' };

  constructor(
    private consultaSql: ConsultasSqlApi,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router,
    public authService: AuthService
  ) {
    if (!this.authService.userData) {
      this.router.navigateByUrl('login-cliente');
    }
  }

  ngOnInit(): void {
    this.cargar();
  }

  cargar(): void {
    this.spinner.show();
    this.consultaSql.GetStoreDinamic({
      nombreStore: 'GetParametros',
      data: null
    }).subscribe(
      (respuesta: any) => {
        this.spinner.hide();
        const filas = respuesta && respuesta[0] ? respuesta[0] : [];
        this.parametros = filas.length === 0 ? [] : filas;
        this.editando = null;
      },
      () => {
        this.spinner.hide();
        this.toastr.error('No se pudieron cargar los parámetros. ¿Corriste docs/sql/05-abm-parametros.sql?');
      }
    );
  }

  editar(item: ParametroItem): void {
    this.editando = item;
    this.form = {
      idparametro: item.idparametro,
      nombre: item.nombre,
      valor: item.valor != null ? String(item.valor) : '',
      descripcion: item.descripcion || ''
    };
  }

  cancelar(): void {
    this.editando = null;
    this.form = { nombre: '', valor: '', descripcion: '' };
  }

  guardar(): void {
    if (!this.form.nombre) {
      this.toastr.warning('Seleccioná un parámetro');
      return;
    }
    if (this.form.valor == null || String(this.form.valor).trim() === '') {
      this.toastr.warning('Ingresá un valor');
      return;
    }

    this.spinner.show();
    this.consultaSql.GetStoreDinamic({
      nombreStore: 'UpdateParametro',
      data: {
        nombrefiltro: this.form.nombre,
        valornuevo: String(this.form.valor).trim(),
        descripcionnueva: this.form.descripcion != null ? String(this.form.descripcion) : ''
      }
    }).subscribe(
      () => {
        this.spinner.hide();
        this.toastr.success('Parámetro actualizado. Recargá display-cliente-v2 para aplicarlo.');
        this.cancelar();
        this.cargar();
      },
      () => {
        this.spinner.hide();
        this.toastr.error('Error al actualizar el parámetro');
      }
    );
  }

  volver(): void {
    this.router.navigateByUrl('display-cliente-v2');
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/abm-parametros/abm-parametros.component.ts